import React from 'react'

const PageBackground = ({
  children,
}: {
  children: React.ReactNode
  addClass?: string
}) => {
  return <>{children}</>
}

export default PageBackground
